import { Box, Heading, HStack, Icon, IconButton } from '@chakra-ui/react'
import { ChevronLeft } from 'lucide-react'
import {
  matchRoutes,
  NavLink,
  useLocation,
  useNavigate,
} from 'react-router-dom'

interface HeaderItemProps {
  title?: string
  path: string
}

interface Props {
  title: string
  items?: Array<HeaderItemProps>
  canReturn?: boolean
  matchPaths?: boolean
}

function HeaderItem(props: HeaderItemProps) {
  return (
    <NavLink to={props.path}>
      {({ isActive }) => (
        <Box
          p={2}
          fontSize="sm"
          borderBottom="2px solid"
          borderBottomColor={isActive ? 'primary.500' : 'transparent'}
          color={isActive ? 'primary.500' : undefined}
        >
          {props.title}
        </Box>
      )}
    </NavLink>
  )
}

export function PageHeader(props: Props) {
  const location = useLocation()
  const match = matchRoutes(
    (props.items ?? []).map((ea) => ({ path: ea.path })),
    location,
  )

  const navigate = useNavigate()

  if (props.matchPaths && !match) return null

  return (
    <Box
      px={8}
      borderBottom="1px solid"
      borderBottomColor="gray.300"
      bg="gray.100"
      zIndex={10}
    >
      <HStack gap={0} py={4}>
        {props.canReturn && (
          <IconButton
            mr={2}
            variant="ghost"
            aria-label="Voltar"
            icon={<Icon as={ChevronLeft} strokeWidth={1} />}
            onClick={() => navigate('../')}
          />
        )}

        <Heading fontWeight="light" fontSize="3xl">
          {props.title}
        </Heading>
      </HStack>

      <HStack gap={4}>
        {(props.items ?? [])
          .filter((ea) => ea?.title !== undefined)
          .map((ea) => {
            return <HeaderItem key={ea.path} {...ea} />
          })}
      </HStack>
    </Box>
  )
}
